/**
 * The 'ROTATE_EAST' action.
 * @type {'ROTATE_EAST'}
 * @constant
 */
const ROTATE_EAST = 'ROTATE_EAST';

/**
 * The 'ROLL' action.
 * @type {'ROTATE_NORTH'}
 * @constant
 */
const ROTATE_NORTH = 'ROTATE_NORTH';

/**
 * The 'ROTATE_SOUTH' action.
 * @type {'ROTATE_SOUTH'}
 * @constant
 */
const ROTATE_SOUTH = 'ROTATE_SOUTH';

/**
 * The 'ROTATE_WEST' action.
 * @type {'ROTATE_WEST'}
 * @constant
 */
const ROTATE_WEST = 'ROTATE_WEST';

export {

    ROTATE_EAST,
    ROTATE_NORTH,
    ROTATE_SOUTH,
    ROTATE_WEST
};
